import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray, AbstractControl } from '@angular/forms';
import { ThesesService, Author, ThesesResource } from '../../services/data/theses.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { hasErr, markFormGroupTouched } from 'src/app/shared/validators/form.helper';

@UntilDestroy()
@Component({
  selector: 'app-theses-authors',
  templateUrl: './theses-authors.component.html',
  styleUrls: ['./theses-authors.component.css']
})
export class ThesesAuthorsComponent implements OnInit {

  isZero = true;
  thesesResource: ThesesResource;

  // Reactive
  authorsForm: UntypedFormGroup;

  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private thesesService: ThesesService
    ) {
    }

  _alias: string = '';

  ngOnInit(): void {

    this._route.paramMap.pipe(
      untilDestroyed(this),
      tap(data =>  this._alias = data.get('alias'))
    ).subscribe();


    this.thesesResource = this.thesesService.getTheses();

    this.authorsForm = new UntypedFormGroup({
      lastNameCtrl: new UntypedFormControl(this.thesesResource.mainAuthor?.lastName, Validators.required),
      firstNameCtrl: new UntypedFormControl(this.thesesResource.mainAuthor?.firstName, Validators.required),
      middleNameCtrl: new UntypedFormControl(this.thesesResource.mainAuthor?.middleName),
      contactEmail: new UntypedFormControl(
        this.thesesResource.mainAuthor?.contactEmail,
        [
          Validators.required,
          Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        ]
      ),
      workplace: new UntypedFormControl(this.thesesResource.mainAuthor?.workplace,  Validators.required),
      // otherAuthorsFG: new FormArray([])
      otherAuthorsFG: new UntypedFormArray([])
    });
    // this.thesesService.initResource();
    // this.thesesService = new ThesesService();

    if (this.thesesResource.otherAuthor !== null){
      this.thesesResource.otherAuthor.forEach(oneOfThem => {
        (<UntypedFormArray>this.authorsForm.get('otherAuthorsFG')).push(
          new UntypedFormGroup({
            lastNameCtrl: new UntypedFormControl(oneOfThem?.lastName, Validators.required),
            firstNameCtrl: new UntypedFormControl(oneOfThem?.firstName, Validators.required),
            middleNameCtrl: new UntypedFormControl(oneOfThem?.middleName),
            workplace: new  UntypedFormControl(oneOfThem?.workplace,  Validators.required)
          })
        );
      });
    }

  }

  hasErr(control: AbstractControl, err: string): boolean {
    return hasErr(control, err);
  }

  getFormAnotherAuthors(): UntypedFormArray{
    return (<UntypedFormArray>this.authorsForm.get('otherAuthorsFG')) as UntypedFormArray;
  }
  getFormAnotherAuthorsError(idx:number, cnt: string, err: string): boolean{
     return (this.getFormAnotherAuthors().controls[idx] as UntypedFormGroup).controls[cnt].hasError(err) ;
  }

  addAuthor(): void {
    (<UntypedFormArray>this.authorsForm.get('otherAuthorsFG')).push(
      new UntypedFormGroup({
        lastNameCtrl: new UntypedFormControl('', Validators.required),
        firstNameCtrl: new UntypedFormControl('', Validators.required),
        middleNameCtrl: new UntypedFormControl(''),
        workplace: new  UntypedFormControl('',Validators.required)
      })
    );
  }

  removeAuthor(id: number){
    (<UntypedFormArray>this.authorsForm.get('otherAuthorsFG')).removeAt(id);
  }

  nextPage(): void {
    this.router.navigate(['/theses', this._alias, 'theses-data']);
  }

  onSubmit(){
    console.log(this.authorsForm);
    markFormGroupTouched(this.authorsForm);

    if (!this.authorsForm.valid) return;

    const mainAuthor: Author = new Author(
      this.authorsForm.controls['lastNameCtrl'].value,
      this.authorsForm.controls['firstNameCtrl'].value,
      this.authorsForm.controls['middleNameCtrl'].value,
      this.authorsForm.controls['contactEmail'].value,
      this.authorsForm.controls['workplace'].value,
    );

    const otherAuthors: Author[] = this.authorsForm.controls['otherAuthorsFG'].value
    .map((data: any[]) => new Author(
                              data['lastNameCtrl'],
                              data['firstNameCtrl'],
                              data['middleNameCtrl'],
                              data['contactEmail'],
                              data['workplace']
                              ));

    this.thesesService.pushAuthors(mainAuthor, otherAuthors);
    // console.log(this.thesesService.getTheses());

    this.nextPage();
  }

}
